export default "assets/images/icons/fleche2-bbad18cf.svg";